import NewsTag from 'AWFNews/Data/Entities/NewsTag'
export default class News {

    public id: string = null;
    public headline: string = null;
    public headlineThumb: string = null;
    public intro: string = null;
    public message: string = null;
    public startDate: Date = null;
    public endDate: Date = null;
    public newsOrder: number = null;
    public newsOrderMessage: string = '';
    public newsTimeStamp: Date = null;
    public who: string = null;
    public status: number = null;
    public category: string = null;
    public tags: NewsTag[] = [];
    public tagIds: string[] = [];
    public languageCode: string;

    constructor() { }

    mapStatus(status: number): string {
        switch (status) {
            case 0: return 'nieuw';
            case 1: return 'gepubliceerd';
            case 2: return 'gearchiveerd';
            default: return 'ongekend';
        }
    }
}